<template>
    <activix-confirm-modal
        type="info"
        portal="modal-3"
        :approve-text="$t('general.ok')"
        :show-deny="false"
        :opened="show"
        :disabled="!updateAutomatedSiblings"
        :title="automatedEventTooltip"
        :approve-callback="save"
        @close="close"
    >
        <template #content>
            <activix-radio-group
                class="flex flex-col justify-center mt-4"
                v-model="updateAutomatedSiblings"
            >
                <activix-radio label="none">
                    {{ $t('modal.modifyAutomatedEventCurrent') }}
                </activix-radio>
                <activix-radio label="future">
                    {{ $t('modal.modifyAutomatedEventFuture') }}
                </activix-radio>
                <activix-radio label="all">
                    {{ $t('modal.modifyAutomatedEventAll') }}
                </activix-radio>
            </activix-radio-group>
        </template>
    </activix-confirm-modal>
</template>

<script>
    import { clone } from 'lodash-es';
    import { ActivixRadio, ActivixRadioGroup } from '@/components/activix-ui/index.ts';

    export default {
        emits: ['update:show', 'save'],

        components: {
            ActivixRadio,
            ActivixRadioGroup,
        },
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            payload: {
                type: Object,
                default: null,
            },
            id: {
                type: Number,
                default: null,
            },
        },

        data() {
            return {
                updateAutomatedSiblings: 'none',
            };
        },

        computed: {
            automatedEventTooltip() {
                if (this.payload.delete) {
                    return this.$t('modal.deleteAutomatedEvent');
                }
                return this.$t('modal.modifyAutomatedEvent');
            },
        },

        watch: {
            show(newValue) {
                if (!newValue) {
                    this.updateAutomatedSiblings = 'none';
                }
            },
        },

        methods: {
            close() {
                this.$emit('update:show', false);
            },

            save() {
                const payload = clone(this.payload);
                payload.updateAutomatedSiblings = this.updateAutomatedSiblings;
                this.$emit('save', payload);
                this.close();
            },
        },
    };
</script>
